export const NOT_SET_LABEL = 'Not set';

export const parseBooleanAttribute = (value: string | null): boolean => {
  const normalized = value?.trim().toLowerCase();
  return normalized === 'true' || normalized === '1';
};

/** Returns `null` for unset or non-numeric values rather than NaN. */
export const parseNumericAttribute = (value: string | null): number | null => {
  if (value === null || value.trim() === '') {
    return null;
  }
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

export const isStorableNumericAttribute = (value: number | null): boolean =>
  value !== null && Number.isFinite(value) && value >= 0;
